import {
  BuyerAccount,
  BuyerAccountResponse,
  BuyerAccountUpdateParams,
} from '../../models/buyer-account.model';

export function mapBuyerAccountResponseToModel(
  response: BuyerAccountResponse,
): BuyerAccount {
  return {
    firstName: response.first_name,
    lastName: response.last_name,
    fullName: `${response.first_name} ${response.last_name}`,
    email: response.email,
    roles: response.roles,
    buyerCompanyNumber: response.buyer_company_number,
    activeFlag: response.active_flag,
    createdOn: response.created_on ? new Date(response.created_on) : undefined,
    updatedOn: response.updated_on ? new Date(response.updated_on) : undefined,
  };
}

export function mapBuyerAccountToParams(
  buyer: BuyerAccount,
): BuyerAccountUpdateParams {
  return {
    first_name: buyer.firstName,
    last_name: buyer.lastName,
    email: buyer.email,
    roles: buyer.roles,
    buyer_company_number: buyer.buyerCompanyNumber,
    active_flag: buyer.activeFlag,
    last_login_date: buyer.lastLoginDate,
    updated_on: buyer.updatedOn,
  };
}
